// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1y8bx","label":"LabeledBox_label__1wD5j"};